const SERVICE_LABELS = new Set(['admin', 'studio', 'api', 'cdn']);

/**
 * Tenant label of a hostname. Two host schemes coexist (ADR-001):
 * the existing one puts the service first (`admin.firma.hypecast.one`, tenant = label 1),
 * the self-service one puts the tenant first (`firma.admin.hypecast.one`, tenant = label 0).
 * Label 1 decides: a service name there means the new scheme. No tenant may be named
 * like a service.
 */
export function tenantNameFromHostname(hostname: string): string {
  const labels = hostname.toLowerCase().split('.');
  const second = labels[1];
  if (labels.length >= 3 && second !== undefined && SERVICE_LABELS.has(second)) {
    return labels[0] ?? '';
  }
  return second ?? labels[0] ?? '';
}

/**
 * Hostname of another service of the same tenant, in the scheme the given hostname uses:
 * `admin.j-corp.hypecast.dev` -> `studio.j-corp.hypecast.dev` (service first),
 * `poc11.admin.hypecast.dev` -> `poc11.studio.hypecast.dev` (tenant first).
 */
export function siblingServiceHost(hostname: string, service: string): string {
  const labels = hostname.toLowerCase().split('.');
  const second = labels[1];
  const serviceIndex = labels.length >= 3 && second !== undefined && SERVICE_LABELS.has(second) ? 1 : 0;
  labels[serviceIndex] = service;
  return labels.join('.');
}
